import React from 'react';
import { CONTACT } from '../lib/contactInfo';

// Floating customer-support entry point using the official WhatsApp glyph (not a generic
// chat-bubble icon) on the brand green, positioned above the mobile bottom bar on phones.
const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${CONTACT.whatsappNumber}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp"
    className="fixed z-40 bottom-20 md:bottom-6 right-4 md:right-6 w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
    style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
  >
    <svg viewBox="0 0 32 32" className="w-8 h-8" fill="#ffffff" aria-hidden="true">
      <path d="M16.001 3C9.11 3 3.5 8.61 3.5 15.5c0 2.34.63 4.6 1.83 6.6L3 29l7.1-2.28a12.44 12.44 0 0 0 5.9 1.5h.01c6.9 0 12.5-5.6 12.5-12.5S22.9 3 16 3Zm0 22.79h-.01a10.3 10.3 0 0 1-5.25-1.44l-.38-.22-4.21 1.35 1.37-4.1-.24-.42a10.24 10.24 0 0 1-1.58-5.46c0-5.68 4.62-10.3 10.31-10.3 2.75 0 5.34 1.08 7.28 3.02a10.23 10.23 0 0 1 3.02 7.29c0 5.68-4.63 10.28-10.31 10.28Zm5.65-7.71c-.31-.15-1.83-.9-2.11-1-.28-.1-.49-.15-.69.16-.2.3-.79 1-.97 1.2-.18.2-.36.23-.67.08-.31-.16-1.29-.48-2.46-1.53-.91-.81-1.52-1.82-1.7-2.13-.18-.31-.02-.47.13-.62.14-.14.31-.36.46-.54.15-.18.2-.3.31-.5.1-.2.05-.38-.02-.53-.08-.16-.69-1.67-.95-2.28-.25-.6-.5-.52-.69-.53-.18-.01-.38-.01-.58-.01-.2 0-.53.08-.81.38-.28.3-1.06 1.04-1.06 2.53s1.09 2.94 1.24 3.14c.15.2 2.15 3.28 5.2 4.6.73.31 1.29.5 1.73.64.73.23 1.39.2 1.91.12.58-.09 1.83-.75 2.09-1.47.26-.72.26-1.34.18-1.47-.07-.14-.27-.22-.58-.37Z" />
    </svg>
  </a>
);

export default WhatsAppButton;
